import { Box, Card, CardCover, Stack, Typography, useTheme } from '@mui/joy';

import { openAdClick } from '../../../api_ads_public';
import { AdCta, AdMark } from './AdParts';
import useAdImpression from './useAdImpression';


/**
 * Рекламная карточка в колоде анкет.
 *
 * Визуально повторяет анкету, но с обязательной пометкой и кнопкой
 * действия вместо лайка. Ref для отслеживания видимости вешается
 * на внешний контейнер.
 */
export default function AdDeckCard({ ad, style, onSkip }) {
    const theme = useTheme();
    const { ref, dwellMs } = useAdImpression(ad);

    if (!ad) return null;

    const handleClick = () => openAdClick(ad, dwellMs());

    return (
        <Card
            ref={ref}
            className="card"
            onClick={handleClick}
            style={{
                position: 'absolute',
                width: '95%',
                height: '95%',
                borderRadius: theme.radius.xl,
                border: 0,
                boxShadow: '0 4px 8px rgba(0,0,0,0.2)',
                cursor: 'pointer',
                overflow: 'hidden',
                ...style,
            }}
        >
            <CardCover>
                {ad.image_url && (
                    <img
                        src={ad.image_url}
                        alt=""
                        loading="lazy"
                        style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                    />
                )}
            </CardCover>

            <CardCover
                sx={{
                    background: 'linear-gradient(to top, rgba(0,0,0,0.85) 0%, '
                        + 'rgba(0,0,0,0.25) 45%, rgba(0,0,0,0) 70%)',
                }}
            />

            <Box sx={{ position: 'absolute', top: 12, left: 12, zIndex: 3 }}>
                <AdMark />
            </Box>

            <Box
                sx={{
                    position: 'absolute', bottom: 0, left: 0, right: 0,
                    p: 2.5, zIndex: 3, color: '#fff',
                }}
            >
                <Typography level="h4" sx={{ color: '#fff', mb: 0.5 }}>
                    {ad.title}
                </Typography>
                {ad.text && (
                    <Typography
                        level="body-sm"
                        sx={{ color: 'rgba(255,255,255,.9)', mb: 1.5 }}
                    >
                        {ad.text}
                    </Typography>
                )}

                <Stack direction="row" spacing={1.5} alignItems="center">
                    <AdCta text={ad.cta_text} onClick={handleClick} />
                    {onSkip && (
                        <Box
                            component="button"
                            onClick={(e) => { e.stopPropagation(); onSkip(); }}
                            sx={{
                                border: 0, background: 'transparent', cursor: 'pointer',
                                color: 'rgba(255,255,255,.75)', fontSize: 13,
                                fontFamily: 'inherit', textDecoration: 'underline',
                            }}
                        >
                            Пропустить
                        </Box>
                    )}
                </Stack>

                {ad.brand_name && (
                    <Typography
                        level="body-xs"
                        sx={{ color: 'rgba(255,255,255,.65)', mt: 1.2, fontSize: 10 }}
                    >
                        {ad.brand_name}
                    </Typography>
                )}
            </Box>
        </Card>
    );
}